import { render } from "./ProjectSettingsAccointAddFinish.vue?vue&type=template&id=d882380c"
import script from "./ProjectSettingsAccointAddFinish.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsAccointAddFinish.vue?vue&type=script&lang=js"

import "./ProjectSettingsAccointAddFinish.vue?vue&type=style&index=0&id=d882380c&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__